// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"5967c475","193":"9d14753e","213":"94cf0750","225":"61f3c13d","338":"4436c1c6","470":"3e1c76ad","537":"4e5b27df","553":"155b7bd8","567":"89cb1494","686":"300dddc4","696":"459d844c","752":"c3ed1324","848":"fa831439","982":"9ff9d5cc"}[chunkId] + ".chunk.js";
};